export default "__VITE_PUBLIC_ASSET__3d6dce40__"